




















































// check this out: https://blog.logrocket.com/how-to-write-a-vue-js-app-completely-in-typescript/

// import Vue, { PropType } from 'vue'
import Page from '@/components/layouts/Page.vue'
import { vxm } from '@/state/index'
import PageSection from '@/components/layouts/PageSection.vue'
import ModalDialog from '@/components/appBase/ModalDialog.vue'
import DeleteClientModal from '@/components/clientflow/DeleteClientModal.vue'
import { wait } from '@/lib/utils/wait'

import {
  defineComponent, reactive, toRefs, computed, onBeforeMount,
} from '@vue/composition-api'

const subPages = [
  { title: 'Behandlingslog', nav: { name: 'journal' } },
  { title: 'Stamdata', nav: { name: 'clientInfo' } },
]

const initialState: {
  showDeleteClientModal: boolean;
  loading: boolean;
} = {
  showDeleteClientModal: false,
  loading: false,
}

const ClientPage = defineComponent({
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Page, PageSection, ModalDialog, DeleteClientModal,
  },
  props: {
    clientId: {
      type: String,
      default: '',
    },
  },

  setup(props, context) {
    const state = reactive({ ...initialState })

    const client = computed(() => context.root.$store.getters['clients/getById'](props.clientId))

    const getPageTitle = computed(() => {
      const title = client.value === undefined ? '' : client.value.name
      return title
    })

    const deleteClient = () => {
      state.showDeleteClientModal = true
    }

    const onCancelDeleteClient = () => {
      state.showDeleteClientModal = false
    }

    const onClientDeleted = () => {
      state.showDeleteClientModal = false
      vxm.app.displaySnackBar({
        color: 'success',
        text: 'klienten blev slettet',
      })
      context.root.$router.push({ name: 'clients' })
    }

    onBeforeMount(() => {
      wait(10).then(() => {
        try {
          if (context.root.$store.getters['clients/getById'](props.clientId) === undefined) {
            state.loading = true
            // https://stackoverflow.com/questions/47876754/query-firestore-database-for-document-id
            context.root.$store.dispatch('clients/openDBChannel', {
              where: [['__name__', '==', props.clientId]],
            })
              .then(() => {
                state.loading = false
              })
          }
        } catch (e) {
          state.loading = false
          // TODO:  check the error. It might just be that the dbchanell is already open
        }
      })
    })
    return {
      ...toRefs(state),
      subPages,
      client,
      getPageTitle,
      deleteClient,
      onCancelDeleteClient,
      onClientDeleted,
    }
  },
})

export default ClientPage

